export const defaultDebtScheduleDataForm = {
  debtType: 2,
  debtSpread: 0,
  debtFloor: 0,
  debtCoupon: 0,
  debtDayCount: 3,
  genStart: '',
  genEnd: '',
  frequency: 'Quarterly',
  notional: 100000000,
  amortRate: 0,
};
